import { Form, Select } from 'antd';
import React from 'react';
import { useSelector } from 'react-redux';
import { EmbarcadorProps, Parceiro } from './props';
import { ApplicationState } from '../../store';
import mask from '../../utils/mask';
import TextFilter from '../TextFilter';

const SelectEmbarcador: React.FC<EmbarcadorProps> = ({ name }) => {
  const { Option } = Select;
  const parceiros = useSelector((state: ApplicationState) => state.auth.user?.inscricoesEstaduais);

  const children = [];
  children.push(
    parceiros?.map((item: Parceiro) => (
      <Option
        data-cy="listOption"
        title={item.nomeParceiro}
        className="optionselect"
        value={item.codParceiro}
        key={item.codParceiro}
      >
        Nome: {item.razaoSocial} - Cod: {item.codParceiro}
        <br />
        CNPJ/CPF: {mask('cpfCnpj', item.cnpjcpf)} <br />
        Inscrição estadual: {item.inscricaoEstadual}
        <hr />
      </Option>
    ))
  );

  const onChange = (values: any) => {
    localStorage.setItem(`embarcador${window.location.pathname}`, values);
  };

  return (
    <>
      <Form.Item label={<TextFilter>Embarcador</TextFilter>} name={name ? name : 'embarcador'}>
        <Select
          data-cy="embarcador"
          showSearch
          className="selectInscriEstadual"
          onChange={onChange}
          filterOption={(inputValue, element) =>
            element?.props.children.toString().toLowerCase().includes(inputValue.toLowerCase())
          }
        >
          {children}
        </Select>
      </Form.Item>
    </>
  );
};

export default SelectEmbarcador;
